import { createContext, useCallback, useContext, useState } from 'react';
import { useRoleManagerContext } from '../role-manager/RoleManagerContext';

interface UserDialogContextType {
  chosenTab?: string;
  setChosenTab: (tab: string | undefined) => void;
  isTeamsInstallationOpen: boolean;
  setIsTeamsInstallationOpen: (open: boolean) => void;
}
const UserDialogContext = createContext<UserDialogContextType>({
  setChosenTab: () => {},
  isTeamsInstallationOpen: false,
  setIsTeamsInstallationOpen: () => {},
});

export const UserDialogProvider = ({ children }: { children: React.ReactNode }) => {
  const [chosenTab, setChosenTab] = useState<string>();
  const [isTeamsInstallationOpen, setIsTeamsInstallationOpen] = useState(false);
  return (
    <UserDialogContext.Provider
      value={{
        chosenTab: chosenTab,
        setChosenTab: setChosenTab,
        isTeamsInstallationOpen,
        setIsTeamsInstallationOpen,
      }}
    >
      {children}
    </UserDialogContext.Provider>
  );
};

export const useUserDialogContext = () => {
  const { setChosenTab, chosenTab, isTeamsInstallationOpen, setIsTeamsInstallationOpen } =
    useContext(UserDialogContext);
  const { setRoleManager } = useRoleManagerContext();

  const openDialog = useCallback(
    (chosenTab: string) => {
      setChosenTab(chosenTab);
    },
    [setChosenTab],
  );

  const closeDialog = useCallback(() => {
    setChosenTab(undefined);
    setRoleManager(false);
  }, [setChosenTab, setRoleManager]);

  return {
    chosenTab,
    setChosenTab,
    openDialog,
    closeDialog,
    isOpen: chosenTab !== undefined,
    isTeamsInstallationOpen,
    setIsTeamsInstallationOpen,
  };
};

export { UserDialogContext };
